import { Box, Text, Flex, Image } from "@chakra-ui/react"
import useStore from "../../../store"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { useNavigate } from "react-router-dom"
import { colors } from "../../../utilities/colors"

export default function CouponCard({coupon}) {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const setCouponInfoPageId = useStore((state) => state.setCouponInfoPageId)
  const setDealerDashboardSidePanel = useStore((state) => state.setDealerDashboardSidePanel)
  const setDashboardUnitId = useStore((state) => state.setDashboardUnitId)
  const fetchCoupon = useStore((state) => state.fetchCoupon)
  const couponInState = useStore((state) => state.coupon)
  const coupons = useStore((state) => state.coupons)

  const handleClick = () => {
    if(coupon.id !== couponInState?.id) {
      fetchCoupon(coupon.id)
    }
    if (isMobile) {
      navigate(`/coupons/${coupon.id}`)
    } else {
      setDashboardUnitId(null)
      setCouponInfoPageId(coupon.id)
      setDealerDashboardSidePanel(null)
    }
  }

  const marginValue = isMobile || coupons?.length === 1 ? 0 : 12

  return(
    <Box bg={colors.deepOcean} pb={2} px={2} pt={2} mb={!isMobile && 2} ml={marginValue} mr={marginValue} mx={isMobile ? 2 : ''} borderRadius="md" position="relative" onClick={handleClick} cursor={'pointer'}>
      <Flex alignItems="start" gap={4}>
        {coupon?.attributes['banner-photo-url'] &&
          <Image
            src={coupon?.attributes['banner-photo-url']}
            alt="Coupon Photo"
            boxSize="60px"
            borderRadius="md"
            objectFit="cover"
          />
        }
        <Flex direction="column">
          <Text color={colors.grey100} fontSize="md">{coupon?.attributes['banner-header']}</Text>
          <Text color={colors.grey100} fontSize="md">{coupon?.attributes['banner-body']}</Text>
        </Flex>
        <Flex justifyContent={'flex-end'}>
      </Flex>
      </Flex>
      <Text
          color={colors.green}
          borderBottom="2px solid"
          borderColor={colors.green}
          pb="1px"
          position={'absolute'}
          bottom={'8px'}
          right={"10px"}
        >
          Get started
        </Text>
    </Box>
  )
}